export default __webpack_public_path__ + "static/media/ranking_bg.fefc363d.png";